import { Database } from '@strapi/icons';

const PluginIcon = () => <Database />;

export { PluginIcon };
